import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import { polyfill } from 'react-lifecycles-compat';
import classNames from 'classnames';
import Input from '../Input';
import Icon from '../Icon';
import locale from '../locale';
import createRef from '@roo/create-react-ref/createRef';
import { isArray } from '@utiljs/is';
import { debounce } from '@utiljs/functional';
import { clone } from '@utiljs/clone';
import { contains } from '@utiljs/dom';
import { Manager, Reference, PopperPortal } from '../core/Popper';
import omit from 'lodash/omit';

var AutoComplete = /*#__PURE__*/function (_React$Component) {
  _inherits(AutoComplete, _React$Component);

  var _super = _createSuper(AutoComplete);

  function AutoComplete(props) {
    var _this;

    _classCallCheck(this, AutoComplete);

    _this = _super.call(this, props);
    _this.triggerRef = createRef();
    _this.inputRef = createRef();
    /**
     * 处理onFocus
     */

    _this.handleFocus = function (e) {
      if (_this.props.onFocus && _this.props.onFocus !== AutoComplete.defaultProps.onFocus) {
        _this.props.onFocus(e);
      }

      _this.showDropdown();
    };
    /**
     * 处理onBlur
     */


    _this.handleBlur = function (e) {
      if (_this.props.onBlur && _this.props.onBlur !== AutoComplete.defaultProps.onBlur) {
        _this.props.onBlur(e);
      }
    };
    /**
     * 展示建议选项列表
     *
     * 注：只读/禁用 时，不展示；
     * 建议列表不为数组，或数组长度不大于0时，不展示。
     */


    _this.showDropdown = function () {
      var _this$props = _this.props,
          readOnly = _this$props.readOnly,
          disabled = _this$props.disabled;

      if (readOnly || disabled) {
        return;
      }

      _this.setState({
        suggestionsVisible: true
      });
    };

    _this.hideDropdown = function () {
      _this.setState({
        suggestionsVisible: false
      });
    };

    _this.handleChangeInput = function (e) {
      e.persist();

      _this.handleChange(e.target.value);

      _this.setState({
        value: e.target.value,
        isNotInput: false
      });
    };
    /*
     * 处理input值变化
     */


    _this.handleChange = debounce(function (value) {
      if (_this.props.onChange) {
        _this.props.onChange(value);
      }

      _this.getData(value);
    }, 500);
    /*
    * 选择一项建议时
    */

    _this.handleSelect = function (index) {
      var keyName = _this.props.keyName;

      _this.setState(function (preState) {
        return {
          value: preState.suggestionList[index][keyName],
          suggestionsVisible: false,
          isNotInput: true
        };
      }, function () {
        if (_this.props.onSelect) {
          var suggestionList = _this.state.suggestionList;
          var selectedItem = suggestionList[index];

          _this.props.onSelect(clone(selectedItem));
        }

        if (_this.props.onChange) {
          _this.props.onChange(_this.state.value);
        }
      });
    };
    /**
     * 处理返回的建议列表
     */


    _this.getData = function (queryString) {
      if (_this.props.fetchSuggestions) {
        _this.setState({
          loading: true
        });

        _this.props.fetchSuggestions(queryString, function (suggestionList) {
          if (isArray(suggestionList)) {
            _this.setState({
              suggestionList: suggestionList,
              loading: false
            });
          } else {
            _this.setState({
              loading: false
            });

            throw new TypeError('suggestionList should be an Array');
          }
        });
      }
    };
    /**
     * 鼠标进入组件时
     */


    _this.handleEnter = function () {
      _this.setState({
        showClear: true
      });
    };
    /**
     * 鼠标离开组件时
     */


    _this.handleLeave = function () {
      _this.setState({
        showClear: false
      });
    };

    _this.handleClear = function () {
      _this.handleChange('');

      _this.setState({
        value: ''
      }, function () {
        _this.inputRef.current.focus();
      });
    };

    _this.handleClickOutside = function (event) {
      if (contains(_this.triggerRef.current, event.target)) {
        return;
      }

      event.stopPropagation();

      _this.hideDropdown();
    };

    _this.state = {
      suggestionList: [],
      loading: false,
      suggestionsVisible: false,
      value: props.value || '',
      showClear: false,
      isNotInput: true
    };
    return _this;
  }

  _createClass(AutoComplete, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.disabled && !this.props.readOnly) {
        this.getData(this.state.value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          suggestionList = _this$state.suggestionList,
          loading = _this$state.loading,
          suggestionsVisible = _this$state.suggestionsVisible,
          value = _this$state.value,
          showClear = _this$state.showClear,
          isNotInput = _this$state.isNotInput;

      var _a = this.props,
          disabled = _a.disabled,
          placeholder = _a.placeholder,
          name = _a.name,
          size = _a.size,
          readOnly = _a.readOnly,
          prepend = _a.prepend,
          append = _a.append,
          optionRenderer = _a.optionRenderer,
          optionKeyExtractor = _a.optionKeyExtractor,
          keyName = _a.keyName,
          className = _a.className,
          clearable = _a.clearable,
          popupContainer = _a.popupContainer,
          zIndex = _a.zIndex,
          disablePortal = _a.disablePortal,
          restProps = __rest(_a, ["disabled", "placeholder", "name", "size", "readOnly", "prepend", "append", "optionRenderer", "optionKeyExtractor", "keyName", "className", "clearable", "popupContainer", "zIndex", "disablePortal"]);

      var restDomProps = omit(restProps, ['fetchSuggestions', 'onSelect', 'onChange', 'onBlur', 'onFocus', 'containerClassName']);
      var clsName = classNames('roo-input-group has-icon roo-autoComplete', className);
      return /*#__PURE__*/React.createElement("div", _Object$assign({
        ref: this.triggerRef,
        className: clsName
      }, restDomProps, {
        onMouseEnter: this.handleEnter,
        onMouseLeave: this.handleLeave
      }), /*#__PURE__*/React.createElement(Manager, null, /*#__PURE__*/React.createElement(Reference, {
        innerRef: function innerRef(ref) {
          _this2.autoCompleteRef = ref;
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(Input, {
        autoComplete: "off",
        inputRef: this.inputRef,
        value: value,
        wrapClassName: "autoComplete",
        readOnly: readOnly,
        disabled: disabled,
        placeholder: placeholder,
        name: name,
        size: size,
        onChange: this.handleChangeInput,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        preAppend: prepend,
        afterAppend: append
      }), showClear && clearable && /*#__PURE__*/React.createElement("i", {
        className: "roo-icon addon-icon roo-icon-times-circle has-click",
        onClick: this.handleClear
      }))), /*#__PURE__*/React.createElement(PopperPortal, {
        zIndex: zIndex,
        visible: suggestionsVisible && !disabled && !readOnly,
        container: popupContainer,
        innerProps: {
          useCapture: false
        },
        modifiers: {
          flip: {
            behavior: ['bottom', 'top']
          },
          preventOverflow: {
            enabled: false
          },
          hide: {
            enabled: false
          }
        },
        disablePortal: disablePortal,
        placement: "bottom-start",
        onClickOutside: this.handleClickOutside
      }, function () {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            width: _this2.autoCompleteRef.getBoundingClientRect().width
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "suggestion-list"
        }, loading && /*#__PURE__*/React.createElement("div", {
          className: "roo-dropdown-menu loading",
          style: {
            width: '100%',
            position: 'relative'
          }
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "loading"
        })), !loading && suggestionList.length === 0 && /*#__PURE__*/React.createElement("div", {
          className: "roo-dropdown-menu other-info",
          style: {
            width: '100%',
            position: 'relative'
          }
        }, locale.lng('AutoComplete.noData')), !loading && suggestionList.length !== 0 && /*#__PURE__*/React.createElement("ul", {
          className: "roo-dropdown-menu",
          style: {
            width: '100%',
            position: 'relative'
          }
        }, suggestionList.map(function (item, index) {
          var key = (optionKeyExtractor || AutoComplete.defaultProps.optionKeyExtractor)(item, index);
          var itemName = optionRenderer && optionRenderer !== AutoComplete.defaultProps.optionRenderer ? optionRenderer(item) : item[keyName];
          return /*#__PURE__*/React.createElement("li", {
            key: key
          }, /*#__PURE__*/React.createElement("a", {
            className: isNotInput && value === item[keyName] ? 'active-highlight' : '',
            onClick: function onClick() {
              return _this2.handleSelect(index);
            }
          }, itemName));
        }))));
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var prevProps = prevState.prevProps || {};

      if (nextProps.value !== undefined) {
        var controlValue = prevProps.value !== nextProps.value ? nextProps.value : prevState.value;
        return {
          value: controlValue,
          prevProps: nextProps
        };
      }

      return null;
    }
  }]);

  return AutoComplete;
}(React.Component);

AutoComplete.propTypes = {
  keyName: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  size: PropTypes.oneOf(['normal', 'small', 'mini']),
  fetchSuggestions: PropTypes.func,
  name: PropTypes.string,
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  optionRenderer: PropTypes.func,
  optionKeyExtractor: PropTypes.func,
  append: PropTypes.any,
  prepend: PropTypes.any,
  className: PropTypes.string,
  clearable: PropTypes.bool,
  disablePortal: PropTypes.bool,
  containerClassName: PropTypes.string,
  popupContainer: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
};
AutoComplete.defaultProps = {
  keyName: 'name',
  placeholder: locale.lng('AutoComplete.placeholder'),
  disabled: false,
  readOnly: false,
  size: 'normal',
  fetchSuggestions: function fetchSuggestions() {},
  name: '',
  onSelect: function onSelect() {},
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  optionRenderer: function optionRenderer() {},
  optionKeyExtractor: function optionKeyExtractor(item) {
    return item.id;
  },
  append: null,
  prepend: null,
  className: '',
  clearable: false,
  containerClassName: '',
  disablePortal: false,
  popupContainer: document.body
};
export default polyfill(AutoComplete);